import React from "react";
import { Status } from "@cinesys/ui/components";
import { Muted } from "./ui";
import { cleanMessage, type JobItem } from "./vaultService";

/** Failed state; the message is ellipsized by its container, so keep the full text on hover. */
export const failedNote = (raw?: string | null) => {
  const message = raw ? cleanMessage(raw) : undefined;
  return (
    <span title={message}>
      <Status type="error">{message ?? "Failed"}</Status>
    </span>
  );
};

/**
 * Per-name state in the job dialogs. Shares "Creating" and the failure look with the sidebar,
 * but a created item says "Created": the sidebar's "Uploaded" would be untrue before any upload.
 */
export const jobItemNote = (item?: JobItem) => {
  if (!item || item.status === "PENDING") {
    return <Status type="placeholder">Creating</Status>;
  }
  if (item.status === "FAILED") {
    return failedNote(item.message);
  }
  if (item.status === "SKIPPED_EXISTS") {
    return <Status type="warn">Already existed</Status>;
  }
  return item.message ? (
    <Muted>{cleanMessage(item.message)}</Muted>
  ) : (
    <Status type="success">Created</Status>
  );
};
